$('.card_video picture').hover(function(){
    const video = $(this).parent().find('[data-video]').text();
     $(this).parent().append(video);
     $(this).parent().find('[data-video]').remove();
})
$('.card_video picture').click(function(){
    $(this).toggleClass('d-none');
})